module.exports = __webpack_public_path__ + "static/home-new-range.2c28e080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-new-range.png
// module id = 184
// module chunks = 35783957827783 142807904292071